import React from 'react';
import StoreProvider from './StoreProvider'

function App() {
  return (
    <StoreProvider />
  );
}

export default App;